import {
  Box,
  Flex,
  HStack,
  IconButton,
  Input,
  Button,
  Select,
  InputGroup,
  InputLeftElement,
  Collapse,
} from "@chakra-ui/react";
import { AnimatePresence, motion } from "framer-motion";
import { get } from "lodash";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FaSearch, FaTimes } from "react-icons/fa";
import { IoSearch } from "react-icons/io5";
import i18next from "i18next";
import { useSelector } from "react-redux";

const GameSearchFilter = ({
  searchQuery,
  setSearchQuery,
  filterCategory,
  setFilterCategory,
  isFilterOpen,
  setIsFilterOpen,
  onClearFilters,
  gamesInfo,
}) => {
  const { t } = useTranslation();

  const { topGameList } = gamesInfo || {};

  // 整理 Select 的資料
  const topGames = useMemo(() => {
    return topGameList || [];
  }, [topGameList]);

  const options = useMemo(() => {
    return topGames.map((game) => ({
      value: game.gameUid,
      label: game?.[`gameNameTw`] || "",
    }));
  }, [topGames]);

  return (
    <Box mb={4}>
      {/* 上方：分類按鈕列與開關 */}
      <Flex
        align={{
          base: "flex-start",
          md: "center",
        }}
        direction={{
          base: "column",
          md: "row",
        }}
        gap={{
          base: 2,
          md: 10,
        }}
      >
        <HStack
          flex={1}
          spacing={2}
          overflowX="auto"
          css={{
            "&::-webkit-scrollbar": { display: "none" },
            "-ms-overflow-style": "none",
            "scrollbar-width": "none",
          }}
          whiteSpace="nowrap"
          pt={1}
        >
          {[
            { id: "new", label: "New" },
            { id: "top", label: "Hot" },
            { id: "favorite", label: "Favorite" },
            { id: "random", label: "Random" },
          ].map((cat) => (
            <Button
              key={cat.id}
              flexShrink={0}
              size="sm"
              onClick={() =>
                setFilterCategory(filterCategory === cat.id ? null : cat.id)
              }
              // Chakra v2 bgGradient 語法修正
              bgGradient={
                filterCategory === cat.id
                  ? "linear(to-b, #538E8D, #17353F)"
                  : "transparent"
              }
              variant={filterCategory === cat.id ? "solid" : "outline"}
              color={filterCategory === cat.id ? "white" : "gray.300"}
              borderRadius="full"
              fontSize="1em"
              px={4}
              h="2.5em"
              border={filterCategory === cat.id ? "none" : "1px solid"}
              borderColor="gray.600"
              _hover={{ opacity: 0.8 }}
            >
              {t(`common.${cat.label}`)}
            </Button>
          ))}
        </HStack>

        <Flex align={"center"} gap={2} pt={2}>
          {/* 左邊：Select 下拉選單 (v2 版本) */}
          <Select
            placeholder={t("common.hot_games", "熱門遊戲")}
            width="120px"
            bg="gray.800"
            borderColor="gray.700"
            color="white"
            fontSize="1em"
            h="2.5em"
            onChange={(e) => {
              const selectedId = e.target.value;
              const item = options.find((i) => i.value == selectedId);
              if (item) setSearchQuery(item.label);
            }}
          >
            {options?.map((item) => (
              <option
                key={item.value}
                value={item.value}
                style={{ background: "#1A202C" }}
              >
                {item.label}
              </option>
            ))}
          </Select>

          {/* 右邊：普通 InputGroup (v2 結構) */}
          <InputGroup flex={1}>
            {/* <InputLeftElement pointerEvents="none" h="full">
              <IoSearch color="gray.500" size="1.2em" />
            </InputLeftElement> */}
            <Input
              placeholder={t(
                "common.search_games_bigger_than_two_words",
                "搜尋遊戲",
              )}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              bg="gray.800"
              color="white"
              fontSize="1em"
              h="2.5em"
              _focus={{ borderColor: "teal.500" }}
            />
          </InputGroup>

          {/* 清除按鈕 */}
          <IconButton
            aria-label="Clear"
            icon={<FaTimes />}
            onClick={onClearFilters}
            variant="ghost"
            colorScheme="red"
            fontSize="1.5em"
            h="1.6em"
            w="1.6em"
          />
        </Flex>
      </Flex>

      {/* 下方：展開的搜尋列 */}
      {/* 使用 Chakra v2 的 Collapse 或維持原本的 motion.div */}
      {/* <AnimatePresence>
        {isFilterOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            style={{ overflow: "hidden" }}
          >
            <Flex align={"center"} gap={2} pt={2}>
               <Select
                placeholder={t("common.hot_games", "熱門遊戲")}
                width="150px"
                bg="gray.800"
                borderColor="gray.700"
                color="white"
                fontSize="1em"
                h="3.2em"
                onChange={(e) => {
                  const selectedId = e.target.value;
                  const item = options.find((i) => i.value == selectedId);
                  if (item) setSearchQuery(item.label);
                }}
              >
                {options.map((item) => (
                  <option
                    key={item.value}
                    value={item.value}
                    style={{ background: "#1A202C" }}
                  >
                    {item.label}
                  </option>
                ))}
              </Select>

               <InputGroup flex={1}>
                <InputLeftElement pointerEvents="none" h="full">
                  <IoSearch color="gray.500" size="1.2em" />
                </InputLeftElement>
                <Input
                  placeholder={t("common.search_games", "搜尋遊戲...")}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  bg="gray.800"
                  color="white"
                  fontSize="1em"
                  //   h="3.2em"
                  _focus={{ borderColor: "teal.500" }}
                />
              </InputGroup>

               <IconButton
                aria-label="Clear"
                icon={<FaTimes />}
                onClick={onClearFilters}
                variant="ghost"
                colorScheme="red"
                fontSize="1.5em"
                h="1.6em"
                w="1.6em"
              />
            </Flex>
          </motion.div>
        )}
      </AnimatePresence> */}
    </Box>
  );
};

export default GameSearchFilter;
